import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

import {useClassNames} from "../../../Hooks/StyleHooks";

import {StreamBankPageHeader} from "../../Common/StreamBankPageHeader";
import {ForgotPasswordComponent} from "./ForgotPasswordComponent";

export const ForgotPasswordPage = props => {
    const classNames = useClassNames('sb-forgot-password-page');

    return <Container className={classNames}>
        <div className="login-page">
            <StreamBankPageHeader
                Title={"Forgot Password"}
            />
            <Row key={1}>
                <Col xs={12} md={12}>
                    <h2>Forgot Password</h2>
                    <hr />
                </Col>
            </Row>
            <Row key={2}>
                <ForgotPasswordComponent />
            </Row>
        </div>
    </Container>;
}


